import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
// Lazy load shared chart components
const SharedPieChart = React.lazy(() => import("../../Sharedpiechart"));
const TITLE =
  "حاسبة نسبة النجاح والرسوب - احسب نسبة النجاح والفشل بدقة وسهولة";
const DESCRIPTION =
  "حاسبة نسبة النجاح والرسوب تساعدك على حساب معدل النجاح ونسبة الرسوب بناءً على عدد الناجحين والراسبين. أداة مجانية دقيقة لحساب نسب النجاح في الاختبارات والامتحانات الدراسية.";
const KEYWORDS =
  "نسبة النجاح, نسبة الرسوب, حاسبة النجاح, حساب نسبة النجاح, معدل النجاح, نسبة الفشل, حاسبة نسبة النجاح والرسوب, احسب نسبة النجاح";
const OG_URL = "https://do-calculate.com/calculator/ar/success-failure-rate/";
function Calculator() {
  // Main Calculator State
  const [totalAttempts, setTotalAttempts] = useState("");
  const [successCount, setSuccessCount] = useState("");
  const [failurePercentage, setFailurePercentage] = useState("");
  const [successPercentage, setSuccessPercentage] = useState("");
  const [error, setError] = useState("");
  const [showChart, setShowChart] = useState(false);
  const handleCalculate = () => {
    if (!totalAttempts || !successCount) {
      setError("الرجاء إدخال عدد المحاولات الكلي وعدد النجاحات بشكل صحيح");
      setFailurePercentage("");
      setSuccessPercentage("");
      setShowChart(false);
      return;
    }
    const attempts = parseInt(totalAttempts);
    const success = parseInt(successCount);
    if (
      isNaN(attempts) ||
      isNaN(success) ||
      attempts <= 0 ||
      success < 0 ||
      success > attempts
    ) {
      setError(
        "الرجاء إدخال قيم صحيحة (عدد النجاحات يجب أن يكون أقل من أو يساوي عدد المحاولات)"
      );
      setFailurePercentage("");
      setSuccessPercentage("");
      setShowChart(false);
      return;
    }
    const failureCount = attempts - success;
    const succPercentage = (success / attempts) * 100;
    const failPercentage = (failureCount / attempts) * 100;
    setSuccessPercentage(succPercentage.toFixed(2));
    setFailurePercentage(failPercentage.toFixed(2));
    setError("");
    setShowChart(true);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <MobileUnderCalAds />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p> إن كنت تبحث عن أداة فعالة لحساب نسبة النجاح والرسوب في الاختبارات والامتحانات الدراسية، فإن حاسبة نسبة النجاح والرسوب هي الحل الأمثل لك. تتيح لك هذه الأداة البسيطة والمجانية حساب معدل النجاح ونسبة الفشل بدقة وسهولة، مما يساعدك على تقييم الأداء الأكاديمي واتخاذ القرارات المناسبة بناءً على البيانات.</p>
              <p>استخدم هذه الحاسبة لإدخال عدد المحاولات الكلي وعدد النجاحات، وستحصل على نسب النجاح والرسوب بشكل فوري ودقيق.</p>
              مثال على كيفية استخدام الحاسبة:
              <ul>
                <li>أدخل العدد الإجمالي للمحاولات (عدد الطلاب أو الأشخاص الذين خضعوا للاختبار).</li>
                <li>أدخل عدد النجاحات (عدد الطلاب أو الأشخاص الذين نجحوا في الاختبار).</li>
                <li>اضغط على زر "احسب النسبة" للحصول على نسبة النجاح ونسبة الرسوب.</li>
              </ul>
              <hr />
            </div>
            <br />
          </div>
          <div className="border border-light">
            {/* Main Calculator */}
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة نسبة النجاح والرسوب
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group mb-3">
                    <label >
                      <b>عدد المحاولات الكلي:</b>
                    </label>
                    <input
                      type="number"
                      placeholder="أدخل عدد المحاولات الكلي"
                      value={totalAttempts}
                      onChange={(e) => setTotalAttempts(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label >
                      <b>عدد النجاحات:</b>
                    </label>
                    <input
                      type="number"
                      placeholder="أدخل عدد النجاحات"
                      value={successCount}
                      onChange={(e) => setSuccessCount(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button
                    className="btn btn-success btn-lg"
                    onClick={handleCalculate}
                  >
                    احسب النسبة
                  </button>
                  <br/>                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {successPercentage !== "" && (
                          <>
                            <div className="result-box p-3 mb-3 bg-light border">
                              <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                                <b>نسبة النجاح: {successPercentage}%</b>
                              </h3>
                              <p style={{ fontSize: "16px", color: "#666" }}>
                                عدد النجاحات: {successCount} من أصل {totalAttempts}
                              </p>
                            </div>
                            <div className="result-box p-3 mb-3 bg-light border">
                              <h3 style={{ fontSize: "18px", color: "#dc3545" }}>
                                <b>نسبة الرسوب: {failurePercentage}%</b>
                              </h3>
                              <p style={{ fontSize: "16px", color: "#666" }}>
                                عدد الإخفاقات: {totalAttempts - successCount} من أصل {totalAttempts}
                              </p>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {showChart && successPercentage && (
                  <React.Suspense
                    fallback={
                      <div className="text-center p-3">
                        جاري تحميل الرسم البياني...
                      </div>
                    }
                  >
                    <SharedPieChart
                      firstLabel="نسبة النجاح"
                      secondLabel="نسبة الرسوب"
                      firstValue={successPercentage}
                      secondValue={failurePercentage}
                      firstColor="#28a745"
                      secondColor="#dc3545"
                      title="الرسم البياني للنسب"
                    />
                  </React.Suspense>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيفية حساب نسبة النجاح ونسبة الرسوب
              </div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>ما هي حاسبة نسبة النجاح والرسوب؟</u>
                  </h2>
                  <p>
                    حاسبة نسبة النجاح والرسوب هي أداة مجانية وسهلة الاستخدام
                    تساعدك على حساب معدل النجاح ونسبة الفشل في الاختبارات
                    والامتحانات الدراسية بدقة عالية. سواء كنت معلماً أو طالباً أو
                    مسؤولاً تعليمياً، فإن هذه الحاسبة توفر لك النتائج الدقيقة
                    التي تحتاجها لتقييم الأداء الأكاديمي.
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>طريقة حساب نسبة النجاح:</u>
                  </h2>
                  <p>
                    لحساب نسبة النجاح، نحتاج إلى معرفة العدد الإجمالي للطلاب (أو
                    الأشخاص) وعدد الناجحين منهم. تُحسب نسبة النجاح بقسمة عدد
                    الناجحين على العدد الإجمالي ثم ضرب الناتج في 100 للحصول على
                    النسبة المئوية.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>معادلة حساب نسبة النجاح:</strong>
                    <br />
                    نسبة النجاح = (عدد الناجحين / العدد الإجمالي) × 100%
                  </div>
                  <p>
                    <strong>مثال عملي:</strong> إذا كان هناك 80 طالباً في صف
                    دراسي، ونجح منهم 64 طالباً، فإن نسبة النجاح = (64 ÷ 80) ×
                    100% = 80%
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>طريقة حساب نسبة الرسوب:</u>
                  </h2>
                  <p>
                    أما نسبة الرسوب أو الفشل، فتُحسب بنفس الطريقة ولكن باستخدام
                    عدد الراسبين بدلاً من الناجحين. يمكن أيضاً حسابها بطرح نسبة
                    النجاح من 100%.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>معادلة حساب نسبة الرسوب:</strong>
                    <br />
                    نسبة الرسوب = (عدد الراسبين / العدد الإجمالي) × 100%
                    <br />
                    أو: نسبة الرسوب = 100% - نسبة النجاح
                  </div>
                  <p>
                    <strong>مثال عملي:</strong> في المثال السابق، عدد الراسبين =
                    80 - 64 = 16 طالباً، فإن نسبة الرسوب = (16 ÷ 80) × 100% =
                    20%، أو ببساطة: 100% - 80% = 20%
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>استخدامات حاسبة نسبة النجاح والرسوب:</u>
                  </h2>
                  <ul>
                    <li>حساب نسبة نجاح الطلاب في الامتحانات الدراسية</li>
                    <li>تقييم أداء الصفوف والمراحل التعليمية المختلفة</li>
                    <li>مقارنة معدلات النجاح بين فصول دراسية متعددة</li>
                    <li>تحليل فعالية طرق التدريس والمناهج الدراسية</li>
                    <li>إعداد التقارير الإحصائية التعليمية</li>
                    <li>متابعة تطور الأداء الأكاديمي</li>
                    <li>تحديد المجالات التي تحتاج إلى تحسين</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>مميزات حاسبة النجاح والرسوب:</u>
                  </h2>
                  <ul>
                    <li>سهولة الاستخدام والواجهة البسيطة</li>
                    <li>حسابات دقيقة وفورية</li>
                    <li>عرض النتائج بشكل واضح ومفهوم</li>
                    <li>رسم بياني دائري توضيحي للنسب</li>
                    <li>أداة مجانية 100%</li>
                    <li>لا تحتاج إلى تسجيل أو اشتراك</li>
                    <li>متوافقة مع جميع الأجهزة</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>نصائح لاستخدام الحاسبة:</u>
                  </h2>
                  <ol>
                    <li>
                      تأكد من إدخال العدد الإجمالي للمحاولات أو الطلاب بشكل صحيح
                    </li>
                    <li>أدخل عدد النجاحات الفعلية بدقة</li>
                    <li>
                      تحقق من أن عدد النجاحات لا يتجاوز العدد الإجمالي للمحاولات
                    </li>
                    <li>استخدم النتائج لاتخاذ قرارات تعليمية مبنية على بيانات</li>
                    <li>احفظ النتائج للمقارنة مع فترات زمنية أخرى</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;